<template>
  <div id='logintitle'>
    <loginPc v-if='onlinestate=="pc"' :gonum='gonum' :handnum='handnum'></loginPc>
    <loginmodel v-else :gonum='gonum' :handnum='handnum'></loginmodel>
    <!-- <handitems2 v-if='isseant2 && handnum != 3 &&handnum != 1&&handnum != 4&&handnum != 5 && cookieFlag'></handitems2> -->
    <!-- <handitems2 v-if='false'></handitems2> -->
    <handitems v-if='!isseant2 && isseant'></handitems>
  </div>
</template>

<script>
  import handitems from './handitems.vue'
  import handitems2 from './handitems2.vue'
  import loginPc from './login_pc.vue'
  import loginmodel from './login_model.vue'
  export default {
    props:['gonum','handnum'],
    components:{loginPc,loginmodel,handitems,handitems2},
    data() {
      return {
        isseant:'',
        isseant2:'',
        cookieFlag:false,
        islang : window.localStorage.guanwanglang,
        onlinestate:sessionStorage['onlinestate']
      }
    },
    mounted() {
      if(!window.sessionStorage['isagree_first']){
        this.isseant = true;
      }
      if(!window.sessionStorage['isagree_second']){
        this.isseant2 = true;
      }
      if(window.localStorage['cookie_second']){
        this.cookieFlag = true;
      }
    },
    methods: {
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/login/login.vue